import { Spin } from "antd";
import React from "react";
import Loader from "react-js-loader";

function LoaderComponent() {
  return (
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "40px",
      marginBottom: "40px",
      paddingTop: window.location.pathname === "/" ? "100px" : "200px",
      paddingBottom: "200px",
    }}
    >
      <Loader
        type="spinner-cub"
        bgColor={"#005299"}
        color={"#0096FF"}
        size={100}
      />
      {/* <Spin
          // spinning={loading}
          size="large"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
            marginBottom: "40px",
            paddingTop: "200px"
          }}
        /> */}
    </div>
  );
}

export default LoaderComponent;
